<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2>
      <span langkey="phWebvoucherModal_Header"></span>
    </h2>
    <div class="webvoucher-dialog-content">
      <p><span langkey="phWebvoucherModal_Text"></span></p>
      <p><span [innerHTML]="note"></span>:</p>
    </div>
    <div class="qrcode-text">
      <h4>{{webVoucherNumber}}</h4>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-container">
        <button mat-button [ngClass]="'mat-button ya-body-1 no-hover'" (click)="RemoveWebvoucher()">
          <span langkey="phWebvoucherModal_RemoveButton_Label"></span>
        </button>
      </div>
    </div>
  </div>
</div>